import {twJoin} from "tailwind-merge";
import {AnankeSkeleton} from "@vesta/ananke/components/anankeSkeleton";

// TODO: Convert this to GenericLoadingComponent, and take border/rounded as props?
export function TableLoadingComponent({className}: {className?: string}) {
    return (
        // <div
        //     className={twJoin(
        //         "w-full h-full rounded-[0.5rem]",
        //         // animate-pulse
        //         // "bg-[#2b2b2b] text-[#ffffff]",
        //         "border-ds-border-width border-solid border-ds-border",
        //         "grid grid-cols-1 grid-rows-1 place-items-center",
        //         className,
        //     )}
        // >
        //     Loading
        // </div>
        <div
            className={twJoin(
                "w-full h-full",
                // "border-ds-border-width border-solid border-ds-border",
                "rounded-[0.5rem]",
                className,
            )}
        >
            <AnankeSkeleton
                width="100%"
                height="100%"
            />
        </div>
    );
}
